import { Box, Typography } from '@material-ui/core';
import { useDownloadTrackRecordTemplate } from '../hooks/useDownloadTrackRecordTemplate';

const NAV_ITEMS: { key: string; label: string }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'addRecords', label: 'Add Records' },
  { key: 'properties', label: 'Properties' },
  { key: 'entities', label: 'Entities' },
  { key: 'licenses', label: 'Licenses' },
];

export const HasRecordsSidebar = ({
  classes,
  selectedNavItem,
  onSelectNavItem,
  verifiedPropertiesCount,
  totalPropertiesCount,
  sectionCounts,
}: {
  classes: Record<string, string>;
  selectedNavItem: string;
  onSelectNavItem: (key: string) => void;
  // Real verified/total properties counts and per-section verified/needsInput splits.
  verifiedPropertiesCount?: number;
  totalPropertiesCount?: number;
  sectionCounts?: Record<string, { verified: number; needsInput: number }>;
}) => {
  const downloadTrackRecordTemplate = useDownloadTrackRecordTemplate();

  const verified = verifiedPropertiesCount ?? 0;
  const total = totalPropertiesCount ?? 0;
  const progressPct = total > 0 ? Math.min(100, (verified / total) * 100) : 0;

  return (
    <Box className={classes.sidebar}>
      <Typography className={classes.sidebarLabel}>Verified Properties</Typography>
      <Box className={classes.sidebarBigNumberRow}>
        <Typography className={classes.sidebarBigNumber}>
          {verified}/{total}
        </Typography>
        <Typography className={classes.sidebarBigNumberLabel}>Verified</Typography>
      </Box>
      <Box className={classes.progressTrack}>
        <Box className={classes.progressFill} style={{ width: `${progressPct}%` }} />
      </Box>
      <Box className={classes.sidebarDivider} />

      <Box className={classes.navList}>
        {NAV_ITEMS.map((item) => {
          const counts = sectionCounts?.[item.key];
          const good = counts?.verified;
          const bad = counts?.needsInput;
          return (
            <Box
              key={item.key}
              className={`${classes.navItem} ${selectedNavItem === item.key ? classes.navItemActive : ''}`}
              onClick={() => onSelectNavItem(item.key)}
            >
              <Typography style={{ fontWeight: 'inherit', fontSize: 14 }}>{item.label}</Typography>
              {(good != null || bad != null) && (
                <Box className={classes.navBadges}>
                  {good != null && <span className={classes.navBadgeGood}>{good}</span>}
                  {bad != null && <span className={classes.navBadgeBad}>{bad}</span>}
                </Box>
              )}
            </Box>
          );
        })}
      </Box>

      <Box className={classes.templateCard}>
        <Typography className={classes.templateCardTitle}>Need the template?</Typography>
        <Typography className={classes.templateCardText}>Excel or CSV extracts most reliably.</Typography>
        <Typography className={classes.templateCardLink} onClick={downloadTrackRecordTemplate}>
          Download Capital Provider Template
        </Typography>
      </Box>
    </Box>
  );
};
